import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { NavigationService } from '../../../services/navigation.service';
import { LeftNav } from '../../../models/navigation.model';
import { Router } from '@angular/router';
import { AccountService } from '../../../services/account.service';
import { SharedService } from '../../../services/shared.service';

@Component({
  selector: 'app-left-nav',
  templateUrl: './left-nav.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LeftNavComponent implements OnInit {
  expanded: boolean = false;
  leftNav: LeftNav;
  userName = '';
  isAdmin = false;
  menuCounts: any = [];
  sharedServiceClient: SharedService;
  constructor(
    private navigationService: NavigationService,
    private ref: ChangeDetectorRef,
    private router: Router,
    private sharedService : SharedService,
    private accountService: AccountService) {
    this.sharedServiceClient = sharedService;
  }

  ngOnInit() {
    this.userName = localStorage.getItem('userName');
    this.isAdmin = !!localStorage.getItem('isAdmin');

    let nav = this.navigationService.getNav();

    if (nav != null) {
      this.expanded = nav.showLeftNav;
    }

    this.navigationService.showLeftNav$.subscribe(s => {
      if (this.leftNav == null) {
        this.leftNav = this.navigationService.getNav().leftNav;
      }
      this.expanded = s;
      this.ref.markForCheck();
    });

    this.navigationService.leftNav$.subscribe(s => {
      this.leftNav = s;
      this.ref.markForCheck();
    });

    this.navigationService.menuCount$.subscribe((res) => {
      if (res.key === 'all') {
        this.menuCounts = res.value;
      } else {
        this.menuCounts = this.menuCounts?.map((menuCount) => {
          const index = res.value.findIndex((r) => { return r.key === menuCount.key });
          if (index > -1) {
            menuCount.cnt = res.value[index].cnt;
          }
          return menuCount;
        })
      }
      this.ref.markForCheck();
    });

  }

  getTotalCount(key: string) {
    return this.menuCounts?.find((res) => res.key == key)?.cnt || 0;
  }

  clickTab(tab: string) {
    if (this.leftNav.tab != 'search' && tab == 'search') {
      this.router.navigateByUrl('/search');
      this.navigationService.setLeftNav('search', 'search');
    }
    else if (this.leftNav.tab == 'search' && tab != 'search') {
      this.router.navigateByUrl('/orders');
      this.navigationService.setLeftNav(tab);
    } else {
      this.navigationService.setLeftNav(tab);
    }
  }

  clickArea(area: string, isChild?: boolean) {
    if (isChild) {
      this.navigationService.setLeftNav(null, null, area);
    } else {
      this.navigationService.setLeftNav(null, area, '');
    }

    switch (area) {
      case "orders":
        this.router.navigateByUrl("/orders");
        break;
      case "invoices":
        this.router.navigateByUrl("/invoices/active");
        break;
      case "completedmoves":
        this.router.navigateByUrl("/invoices/complete");
        break;
      case "account_payable":
        this.router.navigateByUrl("/invoices/account_payable");
        break;
      case "ach":
        this.router.navigateByUrl("/invoices/ach");
        break;
      case "ach_documents_required":
        this.router.navigateByUrl("/invoices/ach_documents_required");
        break;
      case "ach_ready_to_pay":
        this.router.navigateByUrl("/invoices/ach_ready_to_pay");
        break;
      case "ach_ready_to_pay_over_the_next_week":
        this.router.navigateByUrl(
          "/invoices/ach_ready_to_pay_over_the_next_week"
        );
        break;
      case "ach_pay_today":
        this.router.navigateByUrl("/invoices/ach_pay_today");
        break;
      case "mail":
        this.router.navigateByUrl("/invoices/mail");
        break;
      case "mail_documents_required":
        this.router.navigateByUrl("/invoices/mail_documents_required");
        break;
      case "mail_ready_to_pay":
        this.router.navigateByUrl("/invoices/mail_ready_to_pay");
        break;
      case "mail_ready_to_pay_over_the_next_week":
        this.router.navigateByUrl(
          "/invoices/mail_ready_to_pay_over_the_next_week"
        );
        break;
      case "mail_pay_today":
        this.router.navigateByUrl("/invoices/mail_pay_today");
        break;
      case "carrier_payments_on_hold":
        this.router.navigateByUrl("/invoices/carrier_payments_on_hold");
        break;
      case "account_receivable":
         this.router.navigateByUrl("/invoices/account_receivable");
        break;
      case "invoice_needs_to_be_sent":
        this.router.navigateByUrl("/invoices/invoice_needs_to_be_sent");
        break;
      case "customer_billing":
        this.router.navigateByUrl("/invoices/customer_billing");
        break;
      case "late_customer_payment":
        this.router.navigateByUrl("/invoices/late_customer_payment");
        break;
      case "carrier_billing":
        this.router.navigateByUrl("/invoices/carrier_billing");
        break;
      case "late_carrier_payment":
        this.router.navigateByUrl("/invoices/late_carrier_payment");
        break;
      case "commission_info_required":
        this.router.navigateByUrl("/invoices/commission_info_required");
        break;
      case "invoice_totalcost_null":
        this.router.navigateByUrl("/invoices/invoice_totalcost_null");
        break;
      case "ready_to_audit":
        this.router.navigateByUrl("/invoices/ready_to_audit");
        break;
      case "invoices_with_issues":
        this.router.navigateByUrl("/invoices/invoices_with_issues");
        break;
      case "locations":
        this.router.navigateByUrl("/locations");
        break;
      case "users":
        this.router.navigateByUrl("/users");
        break;
      case "quotes":
        this.router.navigateByUrl("/quotes");
        break;
      case "tenders":
        this.router.navigateByUrl("/tenders/blujay/active");
        break;
      case "blujay":
        this.router.navigateByUrl("/tenders/blujay/active");
        break;
      case "proact":
        this.router.navigateByUrl("/tenders/proact/proact_active");
        break;
      case "active":
        this.router.navigateByUrl("/tenders/blujay/active");
        break;
      case "dirty":
        this.router.navigateByUrl("/tenders/blujay/dirty");
        break;
      case "canceled":
        this.router.navigateByUrl("/tenders/blujay/canceled");
        break;
      case "proact_active":
        this.router.navigateByUrl("/tenders/proact/proact_active");
        break;
      case "proact_noreadytoship":
        this.router.navigateByUrl("/tenders/proact/proact_noreadytoship");
        break;
      case "proact_dirty":
        this.router.navigateByUrl("/tenders/proact/proact_dirty");
        break;
      case "proact_canceled":
        this.router.navigateByUrl("/tenders/proact/proact_canceled");
        break;
      case "reporting":
        this.router.navigateByUrl("/reporting");
        break;
    }
  }

  clickChild(child: string) {
    this.navigationService.setLeftNav(null, null, child);
  }

  admin() {
    this.router.navigateByUrl('/admin');
  }

  logout() {
    this.accountService.logout();
  }

  toggleChild(child: any,isSubChild:boolean): void {
    if (isSubChild) {
      this.clickArea(child.key, isSubChild);
    } else {
      this.clickChild(child.key);
    }
    child.isOpen = !child.isOpen;
  }
}
